'use strict';

var $ = require('jquery');
var globalisation = require('../../utilities/globalisation');

exports.phoneNumberLength =  function(value) {
    return value.length <= 20 ? true : false;
};

$.validator.addMethod('phone-number-length', exports.phoneNumberLength, globalisation.pluraliseAndTranslate('account', 'phoneNumberErrorMsg'));



// WEBPACK FOOTER //
// ./assets/js/validators/phone-number-length.js